/* eslint-disable react-hooks/exhaustive-deps */
import FadeIn from 'react-fade-in/lib/FadeIn';
import { Alert, Button, Checkbox, FormControlLabel } from '@mui/material';
import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useSelector, useDispatch } from 'react-redux'
import {
  setAuthen, getBizID
} from '../libs/todoSlice'
import Menu from '@mui/material/Menu';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import LoadingComponent from '../lib/LoadingComponent';
import { Hidden } from "@material-ui/core";

import { RemoveScrollBar } from 'react-remove-scroll-bar';
import TabIndexContent from "react-tabindex-content";
import {
  getUsernameRedux, setUsernameRedux,
  getCheckboxRedux, setCheckboxRedux, getLoadingRedux, setLoadingRedux, getLoginFeedbackRedux, setLoginFeedbackRedux,
  getOpenRedux, setOpenRedux,
  getShowPasswordRedux, setShowPasswordRedux, getPasswordLoginRedux, setPasswordLoginRedux
} from '../libs/loginSlice'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ResetPasswordByOTP from './ResetPasswordByOTP';
import ResetPasswordByEmail from './ResetPasswordByEmail';
import { w3cwebsocket as W3CWebSocket } from 'websocket'
import VerifyDetail from '../components/Login-User/VerifyDetail';

function Login() {
  useEffect(() => {
    const client = new W3CWebSocket(process.env.REACT_APP_BACKEND_WS_URL);
    client.onmessage = ({ data }) => {
      console.log(JSON.parse(data));
    };
  }, []);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const businessID = useSelector(getBizID)
  // const [ backendUrl, setBackendUrl ] = useState('')
  
  // React.useEffect(() => {
  //   let url = window.location.href 
  //   if (url.endsWith('/')) {
  //     url = url.slice(0, -1)
  //   }
  //   setBackendUrl(url)
  // }, [])

  // React.useEffect(()=>{
  //   console.log('backendUrl', backendUrl)
  // }, [backendUrl])

  // const [ username, setUsername ] = useState('')
  // const [ password, setPassword ] = useState('')
  // const [ recaptchaPassed, setRecaptchaPassed ] = useState(false)
  // const [ checkbox, setCheckbox ] = useState(false)
  // const [ loading, setLoading ] = useState(false)
  const [cookie, setCookie, removeCookie] = useCookies(['account', 'new_user', 'oauth_callback', 'cookie_consent_accepting'])
  const searchParams = new URLSearchParams(document.location.search)
  // const [ loginFeedback, setLoginFeedback ] = useState({
  //   message: '',
  //   color: ''
  // })
  // const [open, setOpen] = useState(false);
  const modalOpen = () => setOpen(true);
  const modalClose = () => setOpen(false);

  const [consentModal, setConsentModal] = useState(false);
  const [acceptConsent, setAcceptConsent] = useState(false);
  // const [openChildModal3,setOpenChildModal3] = useState(false);

  // const [resetFeedback,setResetFeedback] = useState({
  //   message: '',
  //   color: ''
  // });


  // useEffect(() => {
  //   console.log(usernamechild);
  // }, [usernamechild]);

  const showPassword = useSelector(getShowPasswordRedux)
  const setShowPassword = (action) => {
    dispatch(setShowPasswordRedux({
      showPassword: action
    }))
  }

  const [anchorEl, setAnchorEl] = useState(null)

  const open = useSelector(getOpenRedux)
  const setOpen = (action) => {
    dispatch(setOpenRedux({
      open: action
    }))
  }



  const username = useSelector(getUsernameRedux)
  const setUsername = (action) => {
    dispatch(setUsernameRedux({
      username: action
    }))
  }

  const password = useSelector(getPasswordLoginRedux)
  const setPassword = (action) => {
    dispatch(setPasswordLoginRedux({
      password: action
    }))
  }


  const checkbox = useSelector(getCheckboxRedux)
  const setCheckbox = (action) => {
    dispatch(setCheckboxRedux({
      checkbox: action
    }))
  }

  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }

  const loginFeedback = useSelector(getLoginFeedbackRedux)
  const setLoginFeedback = (action) => {
    dispatch(setLoginFeedbackRedux({
      loginFeedback: action
    }))
  }




  const usernameRef = useRef()
  useEffect(() => {
    if (searchParams.get('code')) {
      loginWithCode()
    }
  }, []);

  // useEffect(() => {    
  //   let url = new URL(window.location.href)
  //   const searchParams = url.searchParams;
  //   const sharedToken = searchParams.get('shared_token')
  //   if (localStorage.getItem('account') && cookie.access_token && !sharedToken) {
  //     navigate('/businesses/management')
  //   }
  // })
  useEffect(() => {
    document.body.classList.add('login');
    return () => {
      document.body.classList.remove('login');
    }
  })
  const [ mode, setMode ] = useState('pwd')
  const [showVerifyDetail, setShowVerifyDetail] = useState(false);
  useEffect(() => {
    let url = new URL(window.location.href)
    const searchParams = url.searchParams;
    const sharedToken = searchParams.get('shared_token')
    const businessId = searchParams.get('business_id')
    const requestCaURL = searchParams.get('request_ca')
    const client_id = searchParams.get('client_id') 
    if (sharedToken) {
      setMode('shared_token')
      loginWithSharedToken(sharedToken, businessId,requestCaURL, client_id)
    }
    removeCookie('account')
  }, [])


  const loginWithSharedToken = async (sharedToken, businessId, requestCa,clientId) => {
    try {
      const { data } = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/login/shared-token`,
        data: {
          shared_token: sharedToken,
          is_remember: false,
          business_id: businessId ?? null,
          open_ca: requestCa === 'true' ? true : false,
          client_id: clientId,
        }
      })


      setCookie('new_user',
        {
          changed_password: data.data.changed_password,
        }, {
        path: '/',
      })

      dispatch(setAuthen({
        authen: true
      }))

      if (data.data.requested_ca === true) {
        setShowVerifyDetail(true);
        setLoading(false);
        return;
      }

      if (data.data.require_setup_prefix && !data?.data?.prefix) {
        console.log('data.data', data?.data)
        getAccount(null, data?.data?.service, businessId)
        // navigate(`businesses/management`)
      }else if (data.data.prefix) {
        navigate(`/${data.data.prefix}?loading=true`)
      }
      setLoginFeedback({
        message: 'เข้าสู่ระบบสำเร็จ',
        color: 'success'
      })
      getAccount(data.data.prefix)
    } catch ({ response }) {
      setMode('pwd')
      navigate('/')
    }
    setLoading(false)

  }

  const login = async () => {
    setLoading(true)
    setLoginFeedback('')
    try {
      const { data } = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/login-user`,
        data: {
          username: username,
          password: password,
          is_remember: checkbox,
          business_id: businessID
        }
      })
      // if(cookie.cookie_consent_accepting){
      if (!checkbox) {
        setCookie('new_user',
          {
            changed_password: data.data.changed_password,
            // confirmed_email: data.data.confirmed_email,
          }, {
          path: '/',
          // expires: new Date(Date.now()+3600000),
          // httpOnly: true
        })
        dispatch(setAuthen({
          authen: true
        }))
        setLoginFeedback({
          message: 'เข้าสู่ระบบสำเร็จ',
          color: 'success'
        })
        getAccount()
      } else {
        setCookie('remember',
          true,
          {
            path: '/',
            // httpOnly: true
          })
        setCookie('new_user',
          {
            changed_password: data.data.changed_password,
            // confirmed_email: data.data.confirmed_email,
          }, {
          path: '/',
          // httpOnly: true
        })
        dispatch(setAuthen({
          authen: true
        }))
        setLoginFeedback({
          message: 'เข้าสู่ระบบสำเร็จ',
          color: 'success'
        })
        getAccount()
      }
    } catch ({ response }) {
      setLoginFeedback({
        message: 'เข้าสู่ระบบไม่สำเร็จ',
        color: 'error'
      })
    }
    setLoading(false)
  }

  const loginWithCode = async () => {
    setLoading(true)
    setLoginFeedback('')
    try {
      const { data } = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/oauth/token`,
        data: {
          code: searchParams.get('code'),
        }
      })
      // if(cookie.cookie_consent_accepting){
      setCookie('new_user', {
        changed_password: data.data.changed_password,
        // confirmed_email: data.data.confirmed_email,
      }, {
        path: '/',
        // expires: new Date(Date.now()+3600000),
        // httpOnly: true
      })
      dispatch(setAuthen({
        authen: true
      }))
      setLoginFeedback({
        message: 'เข้าสู่ระบบสำเร็จ',
        color: 'success'
      })
      getAccount()
      // }
    } catch ({ response }) {
      setLoginFeedback({
        message: 'เข้าสู่ระบบไม่สำเร็จ',
        color: 'error'
      })
    }
    setLoading(false)
  }

  const oauthRedirect = async () => {
    setCookie('oauth',
      true, {
      path: '/',
      expires: new Date(Date.now() + 3600000),
      // httpOnly: true
    })
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/oauth/code`,
    }).then(({ data, status }) => {
      window.location.href = `${process.env.REACT_APP_ONE_ID}/api/oauth/getcode?client_id=${data.data.clientID}&response_type=code&redirect_uri=${data.data.redirectURL}&scope=title account first_name last_name id_card birth_date email tel pic`
    })
  }

  const getAccount = async (prefix,service,bizId ) => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/user-management`,
    }).then(({ data, status }) => {
      // if(cookie.cookie_consent_accepting){
      let account = { ...data.data}
      delete account.account_attribute
      delete account.account_category
      delete account.address_id
      delete account.blockchain_flg
      delete account.created_by
      delete account.hash_id_card_num
      delete account.id_card_type
      delete account.last_update
      delete account.name_on_document_eng
      delete account.name_on_document_th
      delete account.reason
      delete account.register_dt
      delete account.special_title_name_eng
      delete account.special_title_name_th
      delete account.status_cd
      delete account.status_dt
      delete account.thai_email2
      delete account.thai_email3
      delete account.trust_level
      delete account.updated_at
      delete account.updated_by
      // delete account.email
      delete account.address
      delete account.mobile
      // setCookie('account', 
      // account, {
      //   path: '/' , 
      //   expires: new Date(Date.now()+3600000),
      //   // httpOnly: true
      // })
      localStorage.setItem('account', JSON.stringify(account))
      if(service && bizId){
        localStorage.setItem('set_service_biz', JSON.stringify({service :service, biz_id : bizId}))
      }
      if(prefix){
        const target = `/${prefix}/manage-members`
        navigate(target)
      }
      else if (cookie.oauth_callback) {
        let callback = cookie.oauth_callback
        const target = `/${callback}/manage-members`
        removeCookie('oauth_callback')
        navigate(target)
      } else {
        if (localStorage.getItem('account')) {
          const target = `/businesses/management`
          navigate(target)
        }
      }
      // }
    }, ({ response }) => {
      console.log('response :>> ', response);
    })
  }


  // const [anchorEl, setAnchorEl] = useState(null);
  const handleLogin = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const loginBtn = useRef()

  // const [value, setValue] = useState(null);

  return (
    // showVerifyDetail ? <FadeIn><VerifyDetail /></FadeIn>  :
    showVerifyDetail ? <FadeIn><VerifyDetail /> </FadeIn> :
    <body
      style={{
        // background: '#F8F9FA', 
        height: '100vh',
      }}
    >
      <RemoveScrollBar />
      {mode === 'pwd' ?
      <>
        <div
          className="container"
        >
          <div className="row mt-3 mt-md-5 pe-3 pe-md-0">
            <div className="col-7 col-md-6 text-center text-md-start">
              <img
                style={{
                  maxHeight: '60px',
                  maxWidth: '60px',
                  // boxShadow: '2px 2px 6px',
                  // borderRadius: '5px'
                }}
                onError={({ target }) => {
                  target.src = '/logo_new.png'
                }}
                alt=""
                src={`/one-platform.png`}
              />
              <span
                style={{
                  fontWeight: '600',
                  color: '#053075',
                  padding: '10px',
                }}
              >One Platform</span>
            </div>
            <div className="col-3 col-md-6 text-center text-md-end">
              <Button
                className='mx-auto'
                onClick={handleLogin}
                style={{
                  color: 'white',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '9px 24px',
                  gap: '10px',
                  width: '120px',
                  height: '36px',
                  background: '#053075',
                  borderRadius: '6px',
                  left: '20px',
                  marginRight: '10px',
                }}
              >
                เข้าสู่ระบบ
              </Button>
            </div>
          </div>
        </div>
        <div
          className='d-none d-md-block'
          style={{
            display: 'flex',
            justifyContent: 'right'
          }}
        >
          <img
            src="/img_login_RA_new.png"
            style={{
              position: 'absolute',
              width: '780px',
              height: '780px',
              top: '200px',
              right: '0',
              marginRight: '70px',
              zIndex: '1'
            }}
            alt=''
          />
          <img
            src="/img_login_RA_vector.png"
            style={{
              position: 'absolute',
              top: '270px',
              right: '0',
              zIndex: '0',
              height: '-webkit-fill-available'
            }}
            alt=''
          />
        </div>
        <div
          className='d-none d-md-block'
          style={{
            color: '#053075',
            // display: 'flex',
            // flexDirection: 'column',
            // alignItems: 'flex-start',
            gap: '20px',
            position: 'absolute',
            width: '100%',
            maxWidth: '550px',
            height: '275px',
            left: '84px',
            top: '160px',
            zIndex: '2'
          }}
        >
          <div style={{ fontWeight: '700', fontSize: '34px', lineHeight: '50px', letterSpacing: '0.02em' }}>
            <span>ระบบบริหารจัดการสิทธิ์ <br /> User Management</span>
          </div>
          <div style={{ letterSpacing: '0.05em' }}>
            <span>“ มีเพียง ID เดียว ก็สามารถนำไปใช้งานได้หลากหลายบริการ ภายในหนึ่งหน้า
              โดยใช้ Registration Authority ที่มีการลงทะเบียนรับรองผ่านระบบ <br /> One Platform ”</span>
          </div>
        </div>
      </> 
      : 
        <LoadingComponent />
      }
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          // onClose={handleClose}
          style={{
            top: '70px',
          }}
        >
          <div
            style={{
              padding: '10px 20px',
              width: '308px',
            }}
          >
            <div style={{ padding: '10px', textAlign: 'center' }}>
              <span
                style={{
                  fontSize: '16px',
                }}
                onClose={handleClose}
              >
                <b>เข้าสู่ระบบ</b>
              </span>
            </div>
            <div style={{ textAlign: 'center', margin: '10px' }}>
              <button
                style={{ border: 'none', background: 'none' }}
                onClick={() => {
                  oauthRedirect()
                }}
              >
                <img
                  src="/one-platform.png"
                  style={{
                    width: '36px',
                    height: '100%',
                  }}
                  alt=''
                />
              </button>
            </div>
            <div style={{ textAlign: 'center', margin: '10px' }} ><span>หรือ</span></div>
            <TabIndexContent global={true} allowReadOnly={true}>
              <div className="flex flex-column gap-2" >
                <div style={{ display: 'flex', }}>
                  <label htmlFor="username" style={{ color: 'black' }}>ชื่อผู้ใช้งาน</label>
                </div>
                <OutlinedInput
                  ref={usernameRef}
                  id="username"
                  placeholder="กรอกชื่อผู้ใช้งาน"
                  style={{
                    width: '268px',
                    height: '36px',
                    borderRadius: '6px',
                    // border: '1px solid #EEEEEE',
                    margin: '10px 0',
                  }}
                  value={username}
                  onChange={({ target }) => {
                    setUsername(target.value);
                  }}
                  inputProps={{
                    maxLength: 100,
                    tabIndex: '0'
                  }}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter' && username.length > 0 && password.length > 0) {
                      login()
                    }
                  }}
                />
              </div>
              <div className="flex flex-column gap-2" >
                <div style={{ display: 'flex', }}>
                  <label htmlFor="password" style={{ color: 'black' }}>รหัสผ่าน</label>
                </div>
                <OutlinedInput
                  type={showPassword ? 'text' : 'password'}
                  placeholder="กรอกรหัสผ่าน"
                  style={{
                    width: '268px',
                    height: '36px',
                    borderRadius: '6px',
                    border: '1px solid #EEEEEE',
                    margin: '10px 0',
                  }}
                  value={password}
                  onChange={({ target }) => {
                    setPassword(target.value);
                  }}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter' && username.length > 0 && password.length > 0) {
                      login()
                    }
                  }}
                  inputProps={{
                    maxLength: 100,
                    tabIndex: '1'
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setShowPassword(!showPassword)
                        }}
                        edge="end"
                        style={{ color: '#999999' }}
                        tabIndex="2"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
            </TabIndexContent>
            {
              loginFeedback.message &&
              <FadeIn>
                <div>
                  <Alert variant="filled" severity={loginFeedback.color} style={{ width: '268px' }}>
                    {loginFeedback.message}
                  </Alert>
                </div>
              </FadeIn>
            }

            <div className="col-12">
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={({ target }) => setAcceptConsent(target.checked)}
                  />
                }
                label={
                  <>
                    ยอมรับ
                    <span
                      style={{
                        fontSize: '16px',
                        color: 'rgba(25, 118, 210, 1)',
                        marginLeft: '2px'
                      }}
                      onClick={() => {
                        // setConsentModal(true)
                        window.open('https://one.th/privacy-policy', '_blank');
                      }}
                    >
                      นโยบายคุ้มครองข้อมูลส่วนบุคคล
                    </span>
                  </>
                }
              />

              <Modal
                open={consentModal}
                onClose={() => {
                  setConsentModal(false)
                }}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
              >
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <Box
                        className=""
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          bgcolor: 'background.paper',
                          borderRadius: '16px',
                          boxShadow: 24,
                          width: "100%",
                          maxWidth: "650px",
                          p: 4,
                        }}>
                        <iframe
                          title="Privacy Policy"
                          src='https://one.th/privacy-policy'
                          width="600"
                          height="500"
                        >
                        </iframe>
                        <div className="row mt-2">
                          <div className="col text-end">
                            <Button
                              style={{ fontSize: '16px' }}
                              size='small'
                              onClick={() => {
                                setConsentModal(false)
                              }}>
                              ปิด
                            </Button>
                          </div>
                        </div>
                      </Box>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
            <div className="col-12">
              <FormControlLabel control={<Checkbox onChange={({ target }) => setCheckbox(target.checked)} />} label={<>บันทึกผู้ใช้งานนี้</>} />
              <Button style={{ fontSize: '16px' }} onClick={modalOpen} >ลืมรหัสผ่าน</Button>
              <Modal
                open={open}
                onClose={modalClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
              >
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <Box
                        className=""
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          bgcolor: 'background.paper',
                          // border: '2px solid none'
                          borderRadius: '16px',
                          boxShadow: 24,
                          width: "99%",
                          maxWidth: "500px",
                          p: 4,
                        }}>
                        <div className="row">
                          <div className="col text-center text-md-start">
                            <h2 id="parent-modal-title">รีเซ็ตรหัสผ่าน</h2>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col text-center text-md-start">
                            <p id="parent-modal-description">
                              ท่านจะเลือกรีเซ็ตรหัสผ่านด้วยวิธีใด
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-4 text-center mt-2">
                            <ResetPasswordByEmail />
                          </div>
                          <div className="col-12 col-md-4 text-center mt-2">
                            <ResetPasswordByOTP />
                          </div>
                          <div className="col-12 col-md-4 text-center mt-2">
                            <Button
                              variant="outlined"
                              style={{ borderRadius: '6px', width: '108px', height: '36px', color: '#053075', borderColor: '#053075' }}
                              onClick={modalClose}>
                              ยกเลิก
                            </Button>
                          </div>
                        </div>
                      </Box>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
            <div className="col-12 text-center" style={{ marginTop: '10px' }}>
              <Button
                variant="outlined"
                style={{ borderRadius: '6px', width: '125px', height: '36px', marginRight: '10px', color: '#053075', borderColor: '#053075' }}
                onClick={() => {
                  handleClose()
                  setUsername('')
                  setPassword('')
                  setLoginFeedback({
                    message: '',
                    color: ''
                  })
                }}>
                <span>ยกเลิก</span>
              </Button>
              {loading ?
                <LoadingComponent />
                :
                <Button
                  disabled={username.length === 0 || password.length === 0 || !acceptConsent}
                  variant="contained"
                  style={{ background: '#053075', borderRadius: '6px', width: '125px', height: '36px', }}
                  // disabled={username.length === 0 || password.length === 0 || !checkbox}
                  onClick={() => {
                    login()
                  }}
                  ref={loginBtn}
                >
                  <span style={{ color: 'white' }}>เข้าสู่ระบบ</span>
                </Button>
              }
            </div>
          </div>
        </Menu>
    </body>
  );
}


export default Login;
